module.exports = __webpack_public_path__ + "static/media/rubbish-bin.9394f690.svg";